module.exports = __webpack_public_path__ + "img/posada-cdmx.1f70222a.jpg";